import { Directive, OnDestroy } from '@angular/core';
import { ActivationStart, Router } from '@angular/router';
import { ReplaySubject, Subject, filter, map, switchMap, take, takeUntil } from 'rxjs';
import { CustomerService } from '../services';

@Directive({
    standalone: true,
    selector: '[appRouterValidator]',
})
export class RouterValidatorDirective implements OnDestroy {
    private unsubscribe$ = new Subject<void>();
    private events = new ReplaySubject(1);

    constructor(
        private router: Router,
        private customerService: CustomerService
    ) {
        this.validateRoute();
        this.subscribeActiveDataRoute();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    validateRoute(): void {
        this.customerService
            .getCustomerType()
            .pipe(
                switchMap((userType) => {
                    return this.events.pipe(
                        take(1),
                        map((data) => {
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            const expectedCustomerTypes = (data as any)['expectedCustomerTypes'];
                            return expectedCustomerTypes ? expectedCustomerTypes?.includes(userType) : true;
                        })
                    );
                }),
                takeUntil(this.unsubscribe$)
            )
            .subscribe({
                next: (allowed) => {
                    if (!allowed) {
                        this.router.navigate(['./']);
                    }
                },
            });
    }

    subscribeActiveDataRoute(): void {
        this.router.events
            .pipe(
                filter((event) => event instanceof ActivationStart),
                map((event) => event as ActivationStart),
                map((event) => event.snapshot.data),
                takeUntil(this.unsubscribe$)
            )
            .subscribe((event) => {
                this.events.next(event);
            });
    }
}
